<div class="ipm-ds-row">
    <!-- "SOON" pill only: no LIVE pill while the sale is running -->
    <span class="ipm-ds-live ipm-ds-live-users" *ngIf="!isLive" [class.is-soon]="!isLive">
        <i></i>{{isLive ? 'Live' : 'Soon'}}
        <ng-container *ngFor="let stat of stats">
            <ng-container *ngIf="stat.label === 'active users'">
                <strong>{{stat.value}}</strong>
                <span class="ipm-ds-live-users-label">{{stat.shortLabel}}</span>
            </ng-container>
        </ng-container>
    </span>
    <ng-container *ngFor="let stat of stats; let first = first">
        <ng-container *ngIf="stat.label !== 'active users'">
        <span class="ipm-ds-divider" *ngIf="!first"></span>
        <span class="ipm-ds-chip">
            <!-- live users while the sale runs: the blinking green LIVE dot instead of the icon -->
            <i class="ipm-ds-live-dot" *ngIf="isLive && stat.label === 'live users'; else statIcon"></i>
            <ng-template #statIcon><span class="ipm-ds-chip-icon">{{stat.icon}}</span></ng-template>
            <strong>{{stat.value}}</strong>
            <span class="ipm-ds-chip-label">{{stat.label}}</span>
            <span class="ipm-ds-chip-label-short">{{stat.shortLabel}}</span>
        </span>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="dateText">
        <span class="ipm-ds-divider"></span>
        <span class="ipm-ds-date">🪔 Beat22 Diwali Sale · {{dateText}}</span>
    </ng-container>
    <ng-container *ngIf="showProOffer">
        <span class="ipm-ds-divider"></span>
        <button type="button" class="ipm-ds-pro-offer" (click)="proOffer.emit()">
            <span class="ipm-ds-pro-offer-label">🎁 45% off Pro Annual</span>
            <span class="ipm-ds-pro-offer-label-short">🎁 45% off Pro</span>
            <i class="pi pi-arrow-right"></i>
        </button>
    </ng-container>
</div>
<button type="button" class="ipm-ds-close" (click)="closed.emit()" aria-label="Close Diwali sale strip" title="Close">
    <i class="pi pi-times"></i>
</button>
